import React from "react";
import { useNavigate } from "react-router-dom";

import "./style.css";

import imagemGerarRelatorio from "../../assets/imagem-gerar-relatorios.webp";
import imagemGestaoUsuarios from "../../assets/imagem-gestao-usuarios.webp";
import imagemConfiguracaoVariaveis from "../../assets/imagem-configuracao-variaveis.webp";
import iconeBloqueado from "../../assets/bloqueado.webp";

const CentralControle = () => {
    const navigate = useNavigate(); // Adicione esta linha

    const handleNavegarRelatorios = () => {
        navigate("/relatorios"); // Navega para a página de relatórios
    };

    const handleNavegarGestaoUsuarios = () => {
        navigate("/gestao-usuarios"); // Navega para a página de gestão de usuários
    };

    const handleNavegarConfigurarVariaveis = () => {
        navigate("/configurar-variaveis"); // Navega para a página de gestão de usuários
    };

    const handleNavegarControlePessoas = () => {
        navigate("/controle-pessoas"); // Navega para a página de gestão de usuários
    };

    return (
        <div className="tela">
            <div className="central-controle">
                <h1>Central de Controle</h1>
                <div className="menu-container">
                    <div
                        className="menu-card"
                        onClick={handleNavegarRelatorios}
                    >
                        <img src={imagemGerarRelatorio} alt="Relatórios" />
                        <h2>Relatórios</h2>
                    </div>
                    <div
                        className="menu-card"
                        onClick={handleNavegarGestaoUsuarios}
                    >
                        <img
                            src={imagemGestaoUsuarios}
                            alt="Gestão de Usuários"
                        />
                        <h2>Gestão de Usuários</h2>
                    </div>
                    <div
                        className="menu-card"
                        onClick={handleNavegarConfigurarVariaveis}
                    >
                        <img
                            src={imagemConfiguracaoVariaveis}
                            alt="Configuração de Variáveis"
                        />
                        <h2>Configurar Variáveis</h2>
                    </div>
                    <div
                        className="menu-card"
                        onClick={handleNavegarControlePessoas}
                    >
                        <img src={iconeBloqueado} alt="Controle de Pessoas" />
                        <h2>Controle de Pessoas</h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CentralControle;
